import { FC, FocusEvent, ReactNode, useState } from "react";
import { FormInputProps } from "@otrium/atoms";
import { Error } from "./Input.styled";
import { Field, StyledButton, StyledInput } from "./InputWithButton.styled";

interface Props {
  buttonLabel: ReactNode;
  onButtonClick: () => void;
  buttonDisabled?: boolean;
  buttonLoading?: boolean;
  buttonTestId?: string;
  isError?: boolean;
  isWarning?: boolean;
  errorMessage?: ReactNode;
  inputTestId?: string;
}

const InputWithButton: FC<Props & FormInputProps> = ({
  buttonLabel,
  onButtonClick,
  buttonDisabled,
  buttonLoading,
  buttonTestId = "input-button",
  isError,
  isWarning,
  errorMessage,
  inputTestId = "input",
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (event: FocusEvent<HTMLInputElement>): void => {
    setIsFocused(true);
    rest.onFocus?.(event);
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>): void => {
    setIsFocused(false);
    rest.onBlur?.(event);
  };

  return (
    <div>
      <Field $isError={isError} $isWarning={isWarning} $isFocused={isFocused}>
        {/* @ts-expect-error Fix types issue in the DS */}
        <StyledInput
          {...rest}
          onFocus={handleFocus}
          onBlur={handleBlur}
          data-testid={inputTestId}
        />
        <StyledButton
          type="button"
          variant="secondary"
          disabled={buttonDisabled}
          loading={buttonLoading}
          onClick={onButtonClick}
          data-testid={buttonTestId}
        >
          {buttonLabel}
        </StyledButton>
      </Field>
      {errorMessage && (
        <Error as="div" isWarning={isWarning}>
          {errorMessage}
        </Error>
      )}
    </div>
  );
};

export default InputWithButton;
